import React, { Component } from "react";
import { NavItem, Nav, NavDropdown, MenuItem } from "react-bootstrap";

import { ApolloClient } from 'apollo-client';
import { Query } from "react-apollo";
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

const restLink_account = new HttpLink({
  uri: "/api/v1/account/",
  credentials: 'include'
});
const account_client = new ApolloClient({
 link: restLink_account,
 cache: new InMemoryCache(),
});


class HeaderLinks extends Component {
  render() {
    return (
      <div>
          <Nav pullRight>
          
            <Query
                client={account_client}
                query={gql`{
                  get_authenticated_user{
                    id
                    first_name
                    token
                    profile{
                      is_admin
                    }
                  }
                }
                `}
              >
                {({ loading, error, data }) => {
                  if (loading) return <div>Olá</div>;
                  if (error) return <div>Erro :(</div>;
                    
                  return  (
                    <NavDropdown
                      title={"Olá, "+data.get_authenticated_user.first_name}
                      id="basic-nav-dropdown-right"
                    >
                    
                      <Query
                          client={account_client}
                          query={gql`{
                            account_auth{
                              logout_url
                            }
                          }
                          `}
                        >
                          {({ loading, error, data }) => {
                            if (loading) return <div></div>;
                            if (error) return <div>Erro :(</div>;
                              
                              if(!data.account_auth.logout_url) {
                                return "";
                              }

                            return  (
                                  <NavItem 
                                    data-gtm-type="click" 
                                    data-gtm-clicktype="menu" 
                                    data-gtm-name="Sair"
                                    key={2} 
                                    className="nav-link"
                                    activeClassName="active"
                                    href={data.account_auth.logout_url}>
                                      Sair
                                  </NavItem>
                                );
                              }}
                        </Query>
                    </NavDropdown>
                  );
                }}
              </Query>
            
        </Nav>
        <div className="navbar-right" >
            {/* <form action="/#/search" method="get">
              <input data-gtm-search="input" id="search" type="text" name="s" className="mainLoginInput" placeholder="&#61442;" />
            </form> */}
          </div>
      </div>
    );
  }
}

export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx